import { configureStore } from "@reduxjs/toolkit";
import rbacReducer from "./rbacSlice";
import crmReducer from "./crmSlice";
import ssoReducer from "./ssoSlice";

const store = configureStore({
  reducer: {
    rbac: rbacReducer,
    crm: crmReducer,
    sso: ssoReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
});

export default store;
